export const formatDuration = (seconds, t) => {
  if (!seconds) {
    return t('OVERVIEW_REPORTS.DURATION.NO_ACTIVITY');
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours) {
    return t('OVERVIEW_REPORTS.DURATION.HOURS_MINUTES', { hours, minutes });
  }

  return t('OVERVIEW_REPORTS.DURATION.MINUTES', { minutes });
};
